import { FetchTokenModel } from '../types/fetchTokenModel'
import localStorageEnum from '../enums/localStorageEnum'
import axios, { AxiosResponse } from 'axios'

export const fetchToken = (): Promise<FetchTokenModel> =>
	axios("/auth/token")
		.then((res) => {
			localStorage.setItem(localStorageEnum.accessToken, res.data.token)
			return res.data
		})
		.catch(fetchValidation)

export const fetchValidation = (): Promise<AxiosResponse<void> | void> =>
	axios.post("/auth/validate")
		.then((res) => {
			if (!res.data) {
				localStorage.removeItem(localStorageEnum.accessToken)
				window.location.pathname = '/auth/login'
			}
		})
		.catch(() => {
			localStorage.removeItem(localStorageEnum.accessToken)
			window.location.pathname = '/auth/login'
		})
